module.exports = __webpack_public_path__ + "img/book-quran.03a5497f.svg";